import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  LoginForm,
  LoginFormProps
} from 'record-it-components/form/LoginForm/LoginForm';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { UrlUtils } from 'record-it-utils/utils/UrlUtils/UrlUtils';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { useLoginFunction } from '../../../hooks/authentication/useLoginFunction/useLoginFunction';

export type LoginPageProps = Record<string, never>;

export const LoginPage: FunctionComponent<LoginPageProps> = () => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const login = useLoginFunction({
    onError: () => setErrorMessage(t('components.page.LoginPage.loginFailed'))
  });

  const handleCreateAccount = useEventCallback(() => {
    // TODO:
  });

  const handleForgotPassword: LoginFormProps['onForgotPassword'] =
    useEventCallback((email) => {
      navigate({
        pathname: RoutePaths.forgotPassword(),
        search: UrlUtils.getSearchStringFromMap({ email })
      });
    });

  return (
    <LoginForm
      errorMessage={errorMessage}
      login={login}
      onCreateAccount={handleCreateAccount}
      onForgotPassword={handleForgotPassword}
    ></LoginForm>
  );
};
